import React, { useLayoutEffect, useRef } from "react";

// The one Notes box for the app: the expense form's look — label NOTES, full
// width, nothing typed inside. A note longer than the box wraps onto more lines
// so all of it shows (Maryse, 2 Nov 2026, ZEN-772). A note stays one paragraph:
// Enter moves on like every other field (data-enter="advance") and a pasted
// line break becomes a space.
export function NotesField({ value, onChange, testid, label = "Notes", className = "" }) {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const fit = () => {
      const el = ref.current;
      if (!el) return;
      el.style.height = "auto";
      if (el.scrollHeight) el.style.height = `${el.scrollHeight + 2}px`; // + the 1px border top and bottom
    };
    fit();
    window.addEventListener("resize", fit);
    return () => window.removeEventListener("resize", fit);
  }, [value]);
  return (
    <label className={`block ${className}`}>
      <span className="mb-1 block text-xs font-bold uppercase tracking-wide text-[#6b7280]">{label}</span>
      <textarea ref={ref} rows={1} value={value ?? ""} data-testid={testid} data-enter="advance"
        onChange={(e) => onChange(e.target.value.replace(/\r?\n/g, " "))}
        onKeyDown={(e) => { if (e.key === "Enter") e.preventDefault(); }}
        className="block min-h-[40px] w-full resize-none overflow-hidden rounded-md border border-[#C2C9D1] bg-white px-3 py-[9px] text-sm leading-5 focus:border-[#034AA2] focus:outline-none focus:ring-2 focus:ring-[#034AA2]/30" />
    </label>
  );
}

export default NotesField;
